// AuthCard.js
import React from 'react';
import { Card, CardContent, Typography, Box, useTheme } from '@mui/material';

const AuthCard = ({ title, subtitle, children }) => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                padding: theme.spacing(3),
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                borderRadius: '12px',
                backgroundColor: 'rgba(255, 255, 255, 0.9)', // Slightly transparent background
            }}>
            <CardContent>
                <Typography
                    variant='h3'
                    align='center'
                    sx={{
                        fontWeight: 400,
                        mb: 2,
                        color: 'text.primary',
                        fontSize: theme.breakpoints.down('sm')
                            ? '2rem'
                            : '2.5rem',
                        letterSpacing: '-0.03em',
                        lineHeight: 1.2,
                    }}>
                    {title}
                </Typography>
                <Typography
                    variant='subtitle1'
                    align='center'
                    sx={{
                        mb: 4,
                        color: 'text.secondary',
                        fontSize: theme.breakpoints.down('sm')
                            ? '0.9rem'
                            : '1rem',
                        fontWeight: 300,
                        letterSpacing: '0.02em',
                    }}>
                    {subtitle}
                </Typography>
                {children}
            </CardContent>
        </Card>
    );
};

export default AuthCard;
